export default __webpack_public_path__ + "static/media/18.f736e592.jpg";